'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    EVENTS = _constantsAnalytics2.default.EVENTS,
    ACTIONS = _constantsAnalytics2.default.ACTIONS;


function composeTagsEvent(eventName, tagType, action) {
  var tagCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  return (0, _compose.composeEvent)(eventName, {
    gtmValue: tagCount,
    gtmLabel: tagType,
    gtmCategory: CATEGORIES.TAGS,
    gtmAction: action
  });
}

function composeAddTagsEvent(tagType, tagCount) {
  return (0, _compose.composeAnalytics)([composeTagsEvent(EVENTS.ADD_TAG, tagType, ACTIONS.ADD_CONTENT, tagCount)]);
}

function composeRemoveTagEvent(tagType) {
  return (0, _compose.composeAnalytics)([composeTagsEvent(EVENTS.REMOVE_TAG, tagType, ACTIONS.REMOVE_CONTENT)]);
}

exports.default = {
  composeAddTagsEvent: composeAddTagsEvent,
  composeRemoveTagEvent: composeRemoveTagEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/tagsEventComposer.js
// module id = 589
// module chunks = 0 2 4 5 6 8 9 10 11